/**
 * Creates a hash used for correlationId, requestId and sessionId logging, that is still unique enough but not as
 * long as UUID's.
 */
export function generateHash() {
    var randomBuffer = new Uint32Array(1);
    window.crypto.getRandomValues(randomBuffer);
    var randomNumbers = randomBuffer[0];
    return Math.floor(randomNumbers).toString(16).padEnd(8, '0');
}
